'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
require('backbone-validation');
const i18n = require('i18next');

module.exports.overrideCallbacks = function() {
    _.extend(Backbone.Validation.callbacks, {
        valid: function(view, attr, selector) {
            const el = view.$('[' + selector + '~="' + attr + '"]');
            el.removeClass('has-error');
            el.find('.error').remove();
        },
        invalid: function(view, attr, error, selector) {
            const el = view.$('[' + selector + '~="' + attr + '"]');
            el.addClass('has-error');
            el.find('.form-control').after($(`<p class="error text-danger">${error}</p>`));
        }
    });
};

module.exports.overrideMessages = function() {
    _.extend(Backbone.Validation.messages, {
        required: i18n.t('validation:required')
    });
};




// WEBPACK FOOTER //
// ./balus/util/backbone-validation-override.js